import { MonitoringResultText       } from './monitoring-result-text'      ;
import { MonitoringResultTab        } from './monitoring-result-tab'       ;
import { MonitoringResultConnection } from './monitoring-result-connection';
import { MonitoringResultUser       } from './monitoring-result-user'      ;

export class MonitoringResults {
    texts:            MonitoringResultText      [] = [];
    tabs:             MonitoringResultTab       [] = [];
    connections:      MonitoringResultConnection[] = [];
    neverLoggedUsers: MonitoringResultUser      [] = [];
}
